import React from 'react';
import { BellIcon, SearchIcon, UserIcon } from 'lucide-react';
import { Input } from '../ui/Input';
import { Button } from '../ui/Button';
export function TopBar() {
  return <header className="h-16 border-b border-gray-200 bg-white sticky top-0 z-10 flex items-center justify-between px-6" data-id="element-117">
      <div className="flex items-center flex-1 max-w-md" data-id="element-118">
        <div className="relative w-full" data-id="element-119">
          <SearchIcon className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" data-id="element-120" />
          <Input placeholder="Buscar logs o códigos de cliente (Presiona '/')" className="pl-9 bg-muted/50 border-transparent focus-visible:bg-background h-9" data-id="element-121" />
        </div>
      </div>

      <div className="flex items-center space-x-4" data-id="element-122">
        <div className="flex items-center space-x-2 border-r border-border pr-4" data-id="element-123">
          <span className="flex h-2 w-2 rounded-full bg-green-500 animate-pulse" data-id="element-124"></span>
          <span className="text-xs font-medium text-muted-foreground" data-id="element-125">
            Actualizaciones en Vivo
          </span>
        </div>

        <Button variant="ghost" size="icon" className="relative text-muted-foreground hover:text-foreground" data-id="element-126">
          <BellIcon className="h-5 w-5" data-id="element-127" />
          <span className="absolute top-1.5 right-1.5 h-2 w-2 rounded-full bg-destructive border-2 border-card" data-id="element-128"></span>
        </Button>

        <div className="flex items-center space-x-3 pl-2" data-id="element-129">
          <div className="text-right hidden md:block" data-id="element-130">
            <p className="text-sm font-medium leading-none" data-id="element-131">Gilmar Cáceres</p>
            <p className="text-xs text-muted-foreground mt-1" data-id="element-132">
              Equipo de Operaciones
            </p>
          </div>
          <div className="h-9 w-9 rounded-full bg-primary/10 flex items-center justify-center border border-primary/20" data-id="element-133">
            <UserIcon className="h-4 w-4 text-primary" data-id="element-134" />
          </div>
        </div>
      </div>
    </header>;
}